import React from "react";

const ErrorFallback: React.FC = () => (
  <div>
    <h1>Oops! Something went wrong.</h1>
    <p>
      We're sorry for the inconvenience. Please try refreshing the page or
      contact support if the problem persists.
    </p>
  </div>
);

export default ErrorFallback;
